import type { App } from 'vue';
import { useHeading } from './heading/f-heading';
import { useSelect } from './select/f-select';
import { useButton } from './button/f-button';
import { useTable } from './table/f-table';
import { useStatus } from './status/f-status';

export declare interface Components {
  install: (app: App) => void;
}

export function useComponents() : Components {
  return {
    install: (app: App) => {
      app.use(useButton());
      app.use(useSelect());
      app.use(useHeading());
      app.use(useTable());
      app.use(useStatus());
    },
  };
}